import React, { useEffect, useState } from "react";
import RoomTypeTable from "./Components/RoomTypeTable";
import AddRoomType from "./Components/AddRoomType";
import EditRoomType from "./Components/EditRoomType";
import api from "../../../../api/axios";

const RoomType = () => {
  const [roomType, setRoomType] = useState([]);
  const [selectedRoomType, setSelectedRoomType] = useState(null);
  const [loading, setLoading] = useState(true);

  // ✅ Fetch all facilities
  const fetchRoomType = async () => {
    try {
      // setLoading(true);
      const res = await api.get(`/pms/room-type`);
      setRoomType(res.data.data || []);
    } catch (error) {
      console.error("Failed to fetch facilities:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRoomType();
  }, []);

  const handleDelete = async (id) => {
    await api.delete(`/pms/room-type/${id}`);
    fetchRoomType();
  };

  return (
    <div className="px-xl-5 px-lg-4 px-3 py-3 page-body">
      <div className="row g-3">
        <div className="col-sm-12">
          <div className="d-flex align-items-center justify-content-between flex-wrap">
            <h3 className="fw-bold mb-0">Room List</h3>
            <div className="col-auto d-flex w-sm-100">
              <button
                type="button"
                className="btn btn-dark"
                data-bs-toggle="modal"
                data-bs-target="#add-room-type"
                aria-controls="add-room"
              >
                Add Room
              </button>
            </div>
          </div>
        </div>
        <div className="col-sm-12">
          <div className="card">
            <div className="card-body">
              <RoomTypeTable
                data={roomType}
                loading={loading}
                onEdit={setSelectedRoomType}
                onDelete={handleDelete}
              />
            </div>
          </div>
        </div>
      </div>
      <AddRoomType  onAdded={fetchRoomType} />
      <EditRoomType roomType={selectedRoomType} onUpdated={fetchRoomType} />
    </div>
  );
};

export default RoomType;
